import React from 'react'
import PropTypes from 'prop-types'
import Transactions from './Transactions'
import TransactionDetails from './TransactionDetails'
import ProtectedRoute from '../../internal/ProtectedRoute'
import { Authorities } from '../../models/authorities'
import { TRANSACTION_PAGE_PATH } from './constants'

const TransactionsRoutes = ({ nextRoute, updateRoute }) => {
  return [
    <ProtectedRoute
      key={TRANSACTION_PAGE_PATH}
      exact
      path={TRANSACTION_PAGE_PATH}
      authority={Authorities.TRANSACTIONS}
      page={<Transactions nextRoute={route => nextRoute(route)} />}
    />,
    <ProtectedRoute
      key={`${TRANSACTION_PAGE_PATH}/transaction`}
      exact
      path={`${TRANSACTION_PAGE_PATH}/transaction`}
      authority={Authorities.TRANSACTIONS}
      page={<TransactionDetails newRoute={route => updateRoute(route)} />}
    />,
  ]
}

TransactionsRoutes.propTypes = {
  nextRoute: PropTypes.func.isRequired,
  updateRoute: PropTypes.func.isRequired,
}

export default TransactionsRoutes
